const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

const CART_SELECTION = {
  STORAGE_KEY: 'stonylab_pending_cart_items',
  STORAGE_EXPIRY_KEY: 'stonylab_pending_cart_expiry',
  RETRY_KEY: 'stonylab_pending_cart_retry_after',
  EXPIRY_MS: 24 * 60 * 60 * 1000,
  CHECKBOX_CLASS: 'cart-item__checkbox',
  SELECT_ALL_CLASS: 'cart-item__select-all',
};
